import { render, staticRenderFns } from "./ReservationPointDetail.vue?vue&type=template&id=38f3b96e&scoped=true&"
import script from "./ReservationPointDetail.vue?vue&type=script&lang=js&"
export * from "./ReservationPointDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPointDetail.vue?vue&type=style&index=0&id=38f3b96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3b96e",
  null
  
)

export default component.exports